import styled from 'styled-components';
import { Colors } from '~/config/Colors';
import Card from '~/pages/Sistema/componentes/Card';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  height: calc(100% - 5.5rem);

  .content-oc {
    width: 100%;
  }
`;

export const ThisCard = styled(Card)`
  margin-bottom: 1.3em;
  border-radius: 1em;
  padding: 0.8em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: calc((100% / 4) - 1em);
  height: 5em;
  position: relative;
  overflow: hidden;
  box-shadow: 0px 0px 20px rgba(174, 177, 200, 0.05);
  background: ${Colors.Color1};
  margin-left: 1.2em;

  :nth-child(4n+1) {
    margin-left: 0em;
  }

  .card-color {
    width: 3em;
    height: 3em;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-radius: 4em;
    background: ${props => (props?.cor ? '#' + props?.cor : Colors.Color4)};
  }

  .card-body {
    margin-left: 0.8em;
    width: 100%;

    .card-text {
      display: flex;
      flex-direction: column;
    
    .titulo {
      font-size: 0.75em;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 95%;
      font-weight: 800;
      color: ${Colors.Color7};
    }

    .descricao {
      font-size: 0.66em;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      overflow: hidden;
      font-weight: 800;
      color: ${Colors.Color4};
    }
    
    .cor {
      font-size: 0.68em;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      display: -webkit-box;
      overflow: hidden;
      font-weight: 600;
      margin-top: 0.75em;
      color: ${Colors.Color4};
    }
  }
`;
